import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-p-arrow--down",
  "use": "icon-p-arrow--down-usage",
  "viewBox": "0 0 10 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 15\" id=\"icon-p-arrow--down\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m1 8.794 3.308 3.424V0H5.69v12.217L9 8.794l1 1.034-4.002 4.138H6l-.31.32-.69.715L0 9.83l1-1.035Z\" fill=\"#2B1453\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol